import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function TechnicianLoginPage() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 40, textAlign: "center", position: "relative" }}>
      {/* ❌ X Button in top-right corner */}
      <button
        onClick={() => navigate("/")} // 🔁 Change "/" if you want to navigate somewhere else
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "none",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
          color: "Black"
        }}
      >
        ✖
      </button>

      <h2>Technician Login</h2>

      {/* ✅ Sign Up button */}
      <Link to="/technician-details" style={{ textDecoration: "none" }}>
        <button style={{ ...btnStyle, backgroundColor: "#28a745" }}>
          Sign Up
        </button>
      </Link>

      {/* ✅ Sign In button */}
      <Link to="/technician-signin" style={{ textDecoration: "none" }}>
        <button style={btnStyle}>Sign In</button>
      </Link>
    </div>
  );
}

const btnStyle = {
  padding: "12px 20px",
  margin: "10px",
  fontSize: "16px",
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  width: "200px"
};
